import { TextField } from '@material-ui/core';

import styled from 'styled-components';

import { getColorPrimary, fontFamily } from '../../libs';

export const InputStyled = styled(TextField)`
  margin: 5px 0 !important;

  * {
    font-family: ${fontFamily} !important;
  }

  & input,
  fieldset {
    font-size: 15px !important;
  }

  input ::placeholder,
  input ::-webkit-input-placeholder {
    color: #000000;
    opacity: 0.5 !important;
  }
  input :-ms-input-placeholder {
    color: #000000;
    opacity: 0.5 !important;
  }

  textarea {
    height: 90% !important;
  }

  .MuiSelect-icon {
    top: unset;
    font-size: 30px !important;
  }

  label {
    color: ${({ themecolor }) => themecolor || getColorPrimary};
    font-size: unset !important;
    line-height: unset !important;
  }

  .Mui-error {
    fieldset {
      border-color: #f44336 !important;
    }
  }

  .MuiFormHelperText-root {
    font-size: 12px !important;
    color: ${({ themecolor }) => themecolor || getColorPrimary};
  }

  .MuiFormLabel-root.Mui-focused {
    color: ${({ themecolor }) => themecolor || getColorPrimary} !important;
  }

  .MuiOutlinedInput-input {
    color: ${({ themecolor }) => themecolor || 'inherit'} !important;
  }

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${({ themecolor }) => themecolor || getColorPrimary} !important;
  }

  .MuiOutlinedInput-notchedOutline {
    border-color: ${({ themecolor }) => themecolor || getColorPrimary} !important;
  }

  .MuiInput-underline:after {
    border-bottom-color: ${({ themecolor }) => themecolor || getColorPrimary} !important;
  }

  .MuiOutlinedInput-adornedEnd {
    padding-right: 0;
  }

  .MuiInputLabel-marginDense {
    transform: translate(14px, 10px) scale(1);
  }

  .Mui-disabled {
    fieldset {
      border: 1px solid #00000038 !important;
    }
    input {
      color: #00000060 !important;
    }
  }
`;

export default { InputStyled };
